import React from 'react';
import { useSelector } from 'react-redux';

import { Store } from 'types/store';
import { formatCurrency } from 'utils/formatPrice';
import useViewport from 'utils/useViewportHelper';
import RenewalPrice from '../atoms/RenewalPrice';
import useAmendmentPricing from '../../hooks/useAmendmentPricing';
import useBasketPricing from '../../hooks/useBasketPricing';

const ViewBasket = () => {
  const { monthlyFlex, pageModel, addOns, removedExtras } = useSelector((state: Store) => state?.expiryRenewal) ?? {};
  const { vehicle, member, periodLabel } = useAmendmentPricing();
  const { totalPrice, addOnTotal, wasTotal } = useBasketPricing(addOns?.selected, monthlyFlex, pageModel, vehicle.addedCount, member.addedCount, removedExtras);

  const { isMobile } = useViewport();

  return (
    <>
      <div>
        <RenewalPrice size="lg" price={totalPrice + addOnTotal} wasPrice={wasTotal} />
      </div>
      {pageModel?.discountModel?.isDiscountedPrice && (
        <h5 className={`orange ${isMobile && 'mt-2'}`}>
          {`You're saving ${pageModel?.discountModel?.basketDiscountText} — that's ${formatCurrency((wasTotal ?? 0) - (totalPrice + addOnTotal))}${periodLabel}`}
        </h5>
      )}
      {monthlyFlex ? (
        <p>
          We can’t always split the cost of your cover into equal monthly payments, but you’ll see a full breakdown on the final step.
        </p>
      ) : (
        <p>
          As a reminder, you’re on a {pageModel?.coverPeriod}-month policy.
          {!pageModel?.isMonthlyLongerTermPolicy && ' This price is the total cost for that period.'}
        </p>
      )}
    </>
  );
}

export default ViewBasket;
